import React from "react";
import SEO from "../components/SEO";
import styled from "styled-components";

const RealisationsPageContainer = styled.div`
  padding: 40px 20px;
  max-width: 1200px;
  margin: auto;
`;

const PageTitle = styled.h1`
  text-align: center;
  font-size: 48px;
  color: #13519a;
  margin-bottom: 50px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(350px, 1fr));
  gap: 60px;
  justify-content: center;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 36px;
  }
`;

const ProjectCard = styled.div`
  position: relative;
  background: #222;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
  border: 1.5px solid #13519a;
  min-height: 400px;
  max-width: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s, border-color 0.25s;

  &:hover {
    transform: translateY(-8px) scale(1.01);
    box-shadow: 0 12px 50px rgba(255, 214, 0, 0.22);
    border-color: #ef6500;
  }

  @media (max-width: 640px) {
    border-radius: 9px;
    min-height: 340px;
    max-width: 96vw;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;

  @media (max-width: 640px) {
    height: 165px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 30px 16px 16px 16px;
  background: linear-gradient(0deg, #13519a 72%, rgba(96, 3, 8, 0.03) 100%);
  color: #d8d7dd;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  text-align: center;

  @media (max-width: 640px) {
    padding: 15px 6px 8px 6px;
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: normal;
  margin: 0 0 7px 0;
  color: #d8d7dd;
  width: 100%;
  box-sizing: border-box;
  word-break: break-word;
`;

const CardDescription = styled.p`
  margin: 0 0 9px 0;
  font-size: 1.04rem;
  color: #d8d7dd;
  line-height: 1.52;
  width: 100%;
  box-sizing: border-box;
  word-break: break-word;
`;

const LinkedInLink = styled.a`
  margin-left: auto;
  margin-right: auto;
  background: #13519a;
  color: #d8d7dd;
  padding: 7px 18px;
  border-radius: 22px;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  margin-top: 6px;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 10px rgba(10, 102, 194, 0.16);
  transition: background 0.2s;
  display: inline-block;
  max-width: 100%;
  overflow-wrap: break-word;
  &:hover {
    background: #084076;
  }
`;

const projects = [
  {
    title: "Remplacement Production et Distribution d’Eau Glacée - Tertiaire",
    description:
      "Calorifugeage et isolation des tuyauteries du réseau EG en local technique en ste site occupé à Annemasse.",
    image: process.env.PUBLIC_URL + "/images/calorifugeage-eau-glacee-annemasse.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_chantier-réceptionné-remplacement-de-la-activity-7318233249959342080-3iRC/",
  },
  {
    title: "Cyclo-Filtre",
    description:
      "Mise en place de calorifugeage d'un Cyclo-Filtre - Industrie.",
    image: process.env.PUBLIC_URL + "/images/calorifugeage-cyclo-filtre-industrie.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_cyclo-filtre-bravo-à-nos-équipes-qui-activity-7392894494456639488-gEy3/",
  },
  {
    title: "Isolation Réseau Eau Glacée - Tertiaire",
    description: "Mise en place de Réseaux d'Eau Glacée exterieur.",
    image: process.env.PUBLIC_URL + "/images/isolation-reseau-eau-glacee-exterieur.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_première-partie-de-chantier-terminée-réseaux-activity-7295002209526706176-ZiDm/",
  },
  {
    title: "Isolation Réseau VMC Double-Flux - Habitat",
    description: "Mise en place d'un réseau isolé pour VMC Double-Flux.",
    image: process.env.PUBLIC_URL + "/images/isolation-reseau-vmc-double-flux.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_vmc-double-flux-il-est-primordiale-de-bien-activity-7357667672240574464-vt5r/",
  },
  {
    title: "Calorifugeage Réseaux Extérieurs / Intérieurs - Industie",
    description:
      "Pose de calorifuge sur réseaux extérieurs et intérieurs sur la centrale BioMass de Passy (74).",
    image: process.env.PUBLIC_URL + "/images/calorifugeage-chaufferie-biomasse-passy.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_fin-de-chantier-à-passy-pour-la-chaufferie-activity-7275263331634974721-ZRf9/",
  },
  {
    title: "Calorifuge Réseau de Gaines - Tertiaire",
    description:
      "Mise en place d'un calorifuge sur réseaux de gaines pour la réhabilitation de l'école de Saint Martin d'Uriage (38)",
    image: process.env.PUBLIC_URL + "/images/calorifuge-gaines-ecole-saint-martin-uriage.webp",
    link: "https://www.linkedin.com/posts/impactisol-calorifuge_calorifuge-de-réseaux-de-gaines-pour-la-réhabilitation-activity-7338445479363436545-B2P0/",
  },
];

const Realisations = () => {
  const handleDoubleClick = (link) => {
    if (link) {
      window.open(link, "_blank");
    }
  };

  return (
    <RealisationsPageContainer>
      <SEO
        title="Nos Réalisations | ImpactIsol - Projets d'isolation industrielle"
        description="Découvrez nos réalisations en calorifugeage : chaufferies, réseaux d'eau glacée, VMC double-flux. Projets industriels et tertiaires en Rhône-Alpes."
      />
      <PageTitle>Nos Réalisations</PageTitle>
      <GridContainer>
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            onDoubleClick={() => handleDoubleClick(project.link)}
          >
            <CardImage src={project.image} alt={project.title} />
            <Overlay>
              <CardTitle>{project.title}</CardTitle>
              <CardDescription>{project.description}</CardDescription>
              {project.link && (
                <LinkedInLink
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  Voir sur LinkedIn
                </LinkedInLink>
              )}
            </Overlay>
          </ProjectCard>
        ))}
      </GridContainer>
    </RealisationsPageContainer>
  );
};

export default Realisations;
